module.exports = __webpack_public_path__ + "static/media/envelope3.8c4664d2.png";